import { useEffect, useState } from "react";
import { Send } from "lucide-react";

/**
 * Botón flotante "Inscríbete" que sigue al usuario mientras hace scroll.
 * Aparece tras los primeros 200px de scroll y vibra periódicamente para llamar la atención.
 */
export default function FloatingCTA() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 200);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const handleClick = () => {
        const el = document.getElementById("contacto");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            data-testid="floating-cta-inscribete"
            className={
                "fixed bottom-6 right-6 md:right-8 z-40 inline-flex items-center gap-2 h-14 px-7 rounded-full bg-unemi-orange-primary text-white font-bold text-sm shadow-2xl shadow-unemi-orange-primary/50 hover:bg-unemi-orange-primary/90 hover:scale-110 active:scale-95 transition-all animate-wiggle " +
                (visible
                    ? "opacity-100 translate-y-0 pointer-events-auto"
                    : "opacity-0 translate-y-4 pointer-events-none")
            }
            style={{ transitionProperty: "opacity, transform" }}
        >
            <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
            </span>
            Inscríbete
            <Send className="w-4 h-4" />
        </button>
    );
}
